/* История визитов клиента в карточке: последние 12 заказов, клик открывает заказ. */
import { STATUS, dateShort, money, totals, type Order } from "@okno/shared";
import { useSession } from "../../lib/session";

const SHOWN = 12;

export function ClientHistory({ orders, onOpen }: { orders: Order[]; onOpen: (id: string) => void }) {
  const { boot } = useSession();
  const svcName = (sid: string) => boot.services.find((x) => x.id === sid)?.name || "Услуга";
  return (
    <section>
      <div className="section-title">История · {orders.length}</div>
      <div className="panel">
        <div className="list">
          {orders.length ? (
            orders.slice(0, SHOWN).map((o) => (
              <button key={o.id} className="list-item" onClick={() => onOpen(o.id)}>
                <span className="time-cell" style={{ minWidth: 64 }}>
                  {dateShort(o.start)}
                </span>
                <div className="grow">
                  <div>{o.items.map((it) => svcName(it.sid)).join(", ")}</div>
                  <div className="cell-sub">
                    {STATUS[o.status].label}
                    {o.source === "smart" ? " · смарт-предложение" : ""}
                  </div>
                </div>
                <span className="num">{money(totals(o, boot.settings).total)}</span>
              </button>
            ))
          ) : (
            <div className="list-item muted">Визитов пока нет</div>
          )}
        </div>
      </div>
    </section>
  );
}
